import { ConfigProvider, Table } from "antd";
import React from "react";
import { CheckCircleOutlined } from "@ant-design/icons";
import CustomTag from "./Tags/CustomTag";
import { formatNumber } from "src/utils/formatting";
import FanDTO from "src/models/FanDTO";

const tableTextStyle = {
    fontWeight:'bold',
    fontFamily:'monospace'
}

const columns = [
    {
        title: "Fan",
        dataIndex: "id",
        key: "id",
        width: 200,
        render: (id: string) => <p style={tableTextStyle}>{id}</p>
    },
    {
        title: "State",
        dataIndex: "isOn",
        key: "isOn",
        width: 200,
        render: (isOn : boolean) => isOn ? <CustomTag label={'ON'} icon={<CheckCircleOutlined />} color={'green'} /> : <CustomTag label={'OFF'} icon={<CheckCircleOutlined />} color={'red'} />
    },
    {
        title: "Amps",
        dataIndex: ['fan','current','current_mA'],
        key: "amps",
        width: 200,
        render: (mA: number) => <p style={tableTextStyle}>{formatNumber(((mA/1000)), { decimalPlaces: 1})}</p>
    },
    {
        title: "Pressure (inH2O)",
        dataIndex: "plenumPressure",
        key: "pressure",
        width: 300,
        render: (pressure: number) => <p style={tableTextStyle}>{formatNumber((pressure), { decimalPlaces: 1})}</p>
    },
];

interface FanStateTableProps { 
    data: FanDTO[];
}

const FanStateTable : React.FC<FanStateTableProps> = ({ data }) => {
    return (
        <Table 
        pagination={false} 
        columns={columns} 
        dataSource={data} 
        />
    );
};

export default FanStateTable;
